module.exports = __webpack_public_path__ + "static/media/cityguide-app_2screen.df9248a2.png";